import { render, staticRenderFns } from "./CartFavoriteIcon.vue?vue&type=template&id=16a38846&scoped=true"
import script from "./CartFavoriteIcon.vue?vue&type=script&lang=js"
export * from "./CartFavoriteIcon.vue?vue&type=script&lang=js"
import style0 from "./CartFavoriteIcon.vue?vue&type=style&index=0&id=16a38846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a38846",
  null
  
)

export default component.exports